import categoryPlaceholder from "../assets/category-placeholder.png";

interface CategoryProps {
  name: string;
  placesCount: number;
  imageUrl?: string;
  mini?: boolean;
  onClick?: () => void;
  highlighted?: boolean;
}

export default function Category({
  name,
  placesCount,
  imageUrl,
  mini = false,
  onClick = () => {},
  highlighted = false,
}: CategoryProps) {
  return (
    <div
      className={`p-1 cursor-pointer ${
        mini ? "w-16 sm:w-24 lg:w-32" : "w-40 sm:w-48 lg:w-64"
      } flex-shrink-0`}
      onClick={onClick}
    >
      <div
        className="hover:scale-105 transition-all duration-300 cursor-pointer flex flex-col items-center"
        onClick={onClick}
      >
        <img
          src={imageUrl ? imageUrl : categoryPlaceholder}
          className={`object-cover bg-gray-300 transition-all duration-300 ease-in-out flex-shrink-0
            ${
              mini
                ? "h-16 w-16 sm:h-24 sm:w-24 lg:h-32 lg:w-32 rounded-full"
                : "w-40 h-40 sm:w-48 sm:h-48 lg:w-64 lg:h-64 rounded-t-md"
            }
            ${highlighted ? "border-4 p-1 border-primary" : ""}
          `}
        />
        {mini ? (
          <h1
            className={`text-center text-sm mt-1 truncate w-full px-1 ${
              highlighted ? "text-primary font-bold" : ""
            }`}
          >
            {name}
          </h1>
        ) : (
          <div className="py-4 transition-all duration-300 ease-in-out rounded-b-md flex flex-col gap-0.5 justify-center w-full">
            <span className="truncate">{name}</span>
            {/* <span className="text-gray-400 text-sm">{placesCount} places</span> */}
          </div>
        )}
      </div>
    </div>
  );
}
